import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Hundify har halverat vår admin-tid! Bokningar, fakturor och kommunikation med kunder — allt sköter sig självt.",
    name: "Erik Johansson",
    role: "Ägare",
    company: "Stockholms Hundhotell",
    rating: 5,
  },
  {
    quote: "Den digitala incheckningen är otrolig. Våra kunder älskar att få bilder på sina hundar varje dag.",
    name: "Sofia Berg",
    role: "VD",
    company: "Vovvevillan Dagis",
    rating: 5,
  },
  {
    quote: "GPS-spårningen av våra hundvakter har gett oss en helt ny nivå av professionalism. Riktigt kul jobb!",
    name: "Anders Nyman",
    role: "Grundare",
    company: "Nordic Paws Walking",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-600 dark:text-emerald-400">
            Det säger våra kunder
          </div>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 dark:text-white">
            500+ hundverksamheter litar på oss.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="flex flex-col rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-8 transition-all hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="h-4 w-4 fill-emerald-500 text-emerald-500" />
                ))}
              </div>
              <blockquote className="mt-5 text-slate-800 dark:text-slate-100 text-lg leading-relaxed font-medium">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-slate-100 dark:border-slate-800 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-slate-700 to-slate-900 text-white font-display font-bold flex items-center justify-center">
                  {t.name[0]}
                </div>
                <div>
                  <div className="font-semibold text-slate-900 dark:text-white text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500 dark:text-slate-400">{t.role} · {t.company}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
